'use strict';

module.exports = returner;

function returner(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/util/returner.js
// module id = 445
// module chunks = 95715928098905 168707334958949